import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import {
  ConsultarTarifasColectivosGruposJsonParametros,
  ConsultarTarifasColectivosGruposRequest
} from '../../models/cotizador-contratante/consultar-tarifas-colectivos-grupos/request/consultar-tarifas-colectivos-grupos-request.model';
import { ConsultarTarifasColectivosGruposResponse } from '../../models/cotizador-contratante/consultar-tarifas-colectivos-grupos/response/consultar-tarifas-colectivos-grupos-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarTarifasColectivosGruposService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.COT_CONSULTAR_TARIFA}`;

  constructor(private httpClient: HttpClient) { }

  consultarTarifaColectivoGrupo(params: ConsultarTarifasColectivosGruposJsonParametros): Observable<ConsultarTarifasColectivosGruposResponse> {
    const request: ConsultarTarifasColectivosGruposRequest = {
      nombreClave: 'getCotConsultarTarifa',
      jsonParametros: JSON.stringify(params)
    };

    return this.httpClient.post<ConsultarTarifasColectivosGruposResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en consultarTarifaColectivoGrupo: ', error);
        return throwError(() => new Error(error?.message || 'Error al consultar tarifa (colectivo/grupo)'));
      })
    );
  }
}
